import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';
import { DomSanitizer } from '@angular/platform-browser';

import { LoginPage } from '../login/login';

/**
 * Generated class for the NotifimodalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
	selector: 'page-notifimodal',
	templateUrl: 'notifimodal.html',
})
export class NotifimodalPage {

	loginId: string;
	api_key: string;
	version: string;
	idx: string;
	html: any;

	items: any;
	language: string;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams,
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
        private http: HttpService,
		public app: App,
		private sanitizer: DomSanitizer
	) {
		this.idx = navParams.get('idx');
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
        if(!this.api_key) {
            this.app.getRootNav().setRoot(LoginPage);
        }

        //// 페이지 이름
        localStorage.setItem("pageName", "mygroup");

		this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");
		
		this._init();
	}

	_init() {
		
		let url = "info/notice/index/detail";
		let body = JSON.stringify({ 
			api: this.api_key,
			language: this.language,
			version: this.version,
			idx: this.idx
		});
		this.http.post(url, body).then((res: any) => {
			if(res.result=="OK"){
				if(res.list == undefined) {
					
					return;
				}else {
					this.items = res.list;
					this.html = this.sanitizer.bypassSecurityTrustHtml(res.list.body);
					
				}
			} else if(res.result ==="LOGOUT"){
				
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
				
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
			}
		
		},(err)=>{
			
			let alert = this.alertCtrl.create({
				message: err,
				buttons: ['OK']
			});
			alert.present();
		});
	}
}



// WEBPACK FOOTER //
// ./src/pages/notifimodal/notifimodal.ts